export var UserRole;
(function (UserRole) {
    UserRole["CONSUMER"] = "consumer";
    UserRole["MERCHANT"] = "merchant";
    UserRole["ADMIN"] = "admin";
})(UserRole || (UserRole = {}));
